import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";

import type { SessionResponse } from "../lib/types";

interface AppLayoutProps {
  session: Extract<SessionResponse, { authenticated: true }>;
  offline: boolean;
  children: ReactNode;
}

const links: Array<{ to: string; label: string; icon: string; parentOnly?: boolean }> = [
  { to: "/today", label: "今天", icon: "⌂" },
  { to: "/tasks", label: "所有待辦", icon: "✓" },
  { to: "/stats", label: "統計", icon: "▥" },
  { to: "/esp", label: "花園", icon: "✿", parentOnly: true },
  { to: "/settings", label: "設定", icon: "⚙" },
];

export function AppLayout({ session, offline, children }: AppLayoutProps) {
  return (
    <div className="app-frame">
      <aside className="desktop-sidebar" aria-label="主要導覽">
        <Brand />
        <Navigation canManageDevices={session.capabilities.canManageDevices} />
        <p className="sidebar-member">{session.member.displayName}的家庭</p>
      </aside>
      <div className="app-column">
        {offline ? (
          <div className="offline-banner" role="status">
            <span aria-hidden="true">○</span> 離線瀏覽中，暫時不能修改待辦
          </div>
        ) : null}
        <header className="topbar">
          <div>
            <p className="eyebrow">我們家</p>
            <p className="greeting">{greetingForNow()}，{session.member.displayName}</p>
          </div>
          <span className="member-avatar" aria-hidden="true">
            {session.member.displayName.slice(0, 1)}
          </span>
        </header>
        <main className="page-content">{children}</main>
        <nav className={`mobile-nav${session.capabilities.canManageDevices ? " has-esp" : ""}`} aria-label="主要導覽">
          <Navigation canManageDevices={session.capabilities.canManageDevices} />
        </nav>
      </div>
    </div>
  );
}

function Brand() {
  return (
    <div className="sidebar-brand">
      <span className="brand-dot" aria-hidden="true" />
      <span>我們家</span>
    </div>
  );
}

function Navigation({ canManageDevices }: { canManageDevices: boolean }) {
  return (
    <div className="nav-links">
      {links.filter((link) => !link.parentOnly || canManageDevices).map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          className={({ isActive }) => `nav-link${isActive ? " is-active" : ""}`}
        >
          <span className="nav-icon" aria-hidden="true">{link.icon}</span>
          <span>{link.label}</span>
        </NavLink>
      ))}
    </div>
  );
}

function greetingForNow() {
  const hour = new Date().getHours();
  if (hour < 11) return "早安";
  if (hour < 18) return "午安";
  return "晚安";
}
